export var version = {
  lib: '2.10122.13',
  product: '2.10122.13',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts